import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import BaseModal from '../BaseModal';
import Spinner from 'components/Spinner';
import AddAddressForm from './AddAddressForm';
import { createAddress } from 'actions/addresses';
import { findUser } from 'actions/users';

import styles from './styles.module.scss';
import { getLoggedInUser } from '../../../reducers';

class AddAddressModal extends Component {
  state = {
    isOpen: false,
    loading: false,
    useDefaultAddress: false,
  };

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  handleSubmit = (values) => {
    const { user, createAddress, findUser } = this.props;

    this.setState({ loading: true });
    return createAddress({ user_profile: user.id, ...values })
      .then(() => findUser(user.id))
      .then(() => {
        this.closeModal();
        toast.success('Address created');
      })
      .finally(() => this.setState({ loading: false }));
  };

  setDefaultAddress = () => {
    this.setState({ useDefaultAddress: true });
  };

  render() {
    const { loading, useDefaultAddress, isOpen } = this.state;
    const { user } = this.props;
    const initialValues = useDefaultAddress
      ? {
          full_name: `${user.first_name} ${user.last_name}`,
          address1: '55 Broadway Ave',
          address2: '',
          city: 'New York',
          state: 'NY',
          country: 'USA',
          zip_code: '10006',
        }
      : {
          full_name: `${user.first_name} ${user.last_name}`,
          address1: '',
          address2: '',
          city: '',
          state: '',
          country: 'USA',
          zip_code: '',
        };

    return (
      <React.Fragment>
        <button className="btn btn-default" onClick={this.openModal}>
          Add Address
        </button>

        <BaseModal
          title="Add Address"
          confirmBtnText=""
          cancelBtnText=""
          onClose={this.closeModal}
          isOpen={isOpen}
          className={styles.modal}
        >
          <AddAddressForm
            loading={loading}
            initialValues={initialValues}
            onSubmit={this.handleSubmit}
            setDefaultAddress={this.setDefaultAddress}
          />
          <Spinner showLoader={loading} />
        </BaseModal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loggedInUser: getLoggedInUser(state),
});
const mapDispatchToProps = {
  createAddress,
  findUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddAddressModal);
